import mitt from 'mitt'
const emiter = mitt()
export default emiter
